/** Shopify CDN: Minification failed

Line 93:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 94:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 103:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 108:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 113:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 114:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 115:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 119:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 80:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 81:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 85:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 90:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 95:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 100:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 101:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 102:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 106:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 67:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 68:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 72:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 77:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 82:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 87:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 88:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 89:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 93:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 54:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 55:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 59:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 64:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 69:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 74:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 75:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 76:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 80:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 41:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 42:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 46:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 51:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 56:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 61:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 62:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 63:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 67:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 28:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 29:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 33:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 38:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 48:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 49:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 50:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 54:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 15:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 16:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 20:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 25:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 30:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 35:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 36:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 37:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 41:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('is-active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('is-active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
